export default {
  service_under_construction:
    'Service is being prepared. We are preparing the page to provide better service. We will prepare it and come back to you as soon as possible.',
  bank_product: {
    complete_msg:
      '<span>상품을 가입</span>해 주셔서 진심으로 감사드리며, 더 나은 상품으로 보답하겠습니다.',
  },
  check: '확인',
  verification_code: '인증코드',
  enter_amount: '금액을 입력하세요',
  reg_complete: '가입완료',
  subscription_details: '가입내용',
  select_withdrawal_account: '출금계좌선택',
  email_address: '이메일주소',
  product_info: '상품정보',
  new_amount: '신규금액',
  min_running_amount: '최소실행금액 ',
  max_running_amount: '최대실행금액 ',
  product_type: '상품종류',
  bank_product_name: '상품명',
  reg_start_date: '가입시작일',
  reg_end_date: '가입종료일 ',
  exec_start_date: '실행시작일 ',
  exec_end_date: '실행종료일 ',
  basic_info: '기본정보',
  not_applicable: '해당없음',
  subscription: '가입',
  service_prepare: '서비스 준비중입니다.',
  no_buy_list: '구매내역이 없습니다.',
  no_sell_list: '판매내역이 없습니다.',
  no_list: '목록이 없습니다.',
  dormancy_text1: '복원신청은 최소 1일 또는 5일이 소요됩니다',
  dormancy_text2: '(뱅크 영업 기준)',
  dormancy_text3: '삭제시 잔액 ',
  dormancy_text4: ' 입금 받을계좌 출금계좌번호 선택하세요',
  dormancy_text5: '계좌가 없다면 새로 생성후 신청하시기 바랍니다.',
  dormancy_text6: '삭제하시면 복원하실 수 없습니다.',
  pay: '지불',
  locale_name: '한국어',
  Sale_registration: '판매등록',
  apply: '신청',
  status: '상태',
  wallet: '지갑',
  wallet_address: '지갑 주소',
  wallet_transfer: '지갑 이체',
  history: '내역',
  buy: '구매',
  sell: '판매',
  all: '전체',
  breakdown: '내역',
  act_buy: '구매하기',
  act_sell: '판매하기',
  asset: '자산',
  select: '선택',
  no_select: '선택 없음',
  account: '계좌',
  balance: '잔액',
  login: '로그인',
  logout: '로그아웃',
  register: '회원가입',
  select_cancel: '선택 취소',
  cancel: '취소',
  modify: '수정',
  auto_input: '(자동 입력)',
  confirm: '확정',
  look_up: '조회',
  password: '비밀번호',
  account_delete: '탈퇴',
  detail: '상세',
  list_detail: '내역 상세',
  birth: '생일',
  welcome: '환영합니다.',
  please_login: '로그인 하세요.',
  confirmation_login: '로그인시 확인 가능합니다.',
  id: '아이디',
  find_id: '아이디 찾기',
  find_password: '비밀번호 찾기',
  back: '돌아가기',
  agreement: '약관동의',
  info_input: '정보입력',
  success: '완료',
  agree_msg: '동의합니다.',
  all_agree: '모두 동의합니다.',
  agree: '동의',
  agreed: '동의함',
  confirm_password: '비밀번호 확인',
  repeat_password: '비밀번호 재입력',
  next: '다음',
  before: '이전',
  register_success: '회원가입 되었습니다.',
  verify: '확인',
  retention: '보유',
  allow: '(허용)',
  disallow: '(비허용)',
  upload_btn: '이곳에 파일을 드랍하거나 클릭해 주세요.',
  continue_entry: '계속하시려면 "[+:verification]"를 아래에 입력해 주세요.',
  login_msg_1: '코인관련 계정을 @:(brand.name)에서 이용해 보세요 !',
  login_msg_2:
    '우리 @:(brand.name)를 통해 거래 및 지갑과 서비스를 <br />이용하시기 바랍니다.',
  login_msg_3: '@:(brand.name)는 모든 환경을 지원하고 있습니다.',
  brand_register: '@:(brand.name) 회원가입',
  register_msg_1: '가입을 시작합니다.<br /> 서비스 약관에 동의해주세요.',
  register_msg_3:
    '@:(brand.name) 계정 하나로 모든 서비스를 간편하게 이용하시기 바랍니다.',
  register_msg_all:
    '모두 동의는 필수 및 선택 항목에 대한 동의도 포함되어 있으며, 개별적으로 동의를 선택할 수 있습니다. 선택항목에 대한 동의를 거부하시는 경우에도 서비스는 이용이 가능합니다',
  register_title: '만 19세 이상입니다.',
  register_title_2: '@:(brand.name) 약관',
  register_title_3: '@:(brand.name) 통합서비스 약관',
  register_title_4: '@:(brand.name) 마케팅 활용 동의',
  register_title_5: '개인정보 수집 및 이용 동의',
  register_title_6: '위치정보 수집 및 이용 동의',
  register_title_7: '프로필 정보 추가 수집 동의',
  register_title_8: '@:(brand.name) 계정 정보를 입력해 주세요.',
  register_title_9: '입력정보',
  register_msg_4:
    '본 약관은 회사가 제공하는 모든 서비스 등에 공통 적용되며, <br />본 약관에 동의함으로써 해당 서비스들을 별도 이용계약 체결 없이 이용할 수 있습니다.',
  required: '[필수]',
  option: '[선택]',
  otp_notice: 'OTP 활성화 및 비활성화가 불가능한 상태 입니다.',
  required_check: '필수항목에 모두 체크해주세요',
  check_input: '내용을 모두 입력해주세요.',
  register_guide: '간단한 @:(brand.name) 사용법',
  register_step1: '@:(brand.name) 버튼 클릭',
  register_step2: '@:(brand.name) 로그인',
  register_step3: '@:(brand.name) 결제 / 충전',
  copy: '복사하기',
  no_account: '등록된 계좌가 없습니다.',
  inviter_link: '추천인 링크',
  exchange: '환전',
  register_used_account: '자주 사용하는 계좌 등록',
  security_certification: '보안 인증',
  admin_security: '{action}님의 보안등급은 {limit} 입니다.',
  individual: '개인',
  company: '기업',
  exact_calculation: '정산용',
  profile: '회원 정보',
  information: '정보',
  inquiry: '문의',
  announcement: '공지',
  registration_date: '등록일',
  detail_search: '상세 검색',
  more_view: '자세히 보기',
  exchange_store: '거래소',
  external_exchange_store: '외부 거래소',
  internal_exchange_store: '내부 거래소',
  external_transaction: '외부 거래',
  internal_transaction: '내부 거래',
  favorites: '즐겨찾기',
  no_favorite_list: '즐겨찾기 내역이 없습니다.',
  no_alias: '별칭없음',
  please_enter_account_name: '계좌 이름을 입력해주세요.',
  variable_amount: '변동금액',
  changes: '변동내역',
  account_transaction_history_inquiry: '계좌거래 내역조회',
  exchange_application_completed: '환전 신청 완료되었습니다.',
  choose_how_pay_fee: '수수료 지불 방법 선택',
  free: '무료',
  closing: '종결',
  relative_asset_inquiry: '상대자산 조회',
  please_enter_relative_account_number: '상대 계좌번호를 입력해주세요.',
  Please_enter_relative_wallet_address: '상대 지갑주소를 입력해주세요.',
  memo: '메모',
  write_history_memo: '내역 메모를 적으시면 관리하기 편리 합니다.',
  re_enter: '다시 입력',
  transfer_wallet_account: '이체지갑 주소',
  transfer_wallet_inquiry: '이체지갑 조회',
  Kiosk: '키오스크',
  withdrawable_amount: '출금 가능 금액',
  transferred_assets: '이체 자산',
  recipient: '받는 분',
  recipient_wallet: '받는 분 지갑',
  register_user_name_tit:
    '보안인증을 위해 실명으로 기입하는 것을 권장드립니다.',
  register_password_tit:
    '자주 사용하는 이메일 주소를 정확히 기입해주시기 바랍니다.',
  product_name: '상품명',
  dividend_type: '배당형',
  auto: '자동',
  manual: '수동',
  s_usdt_protocol: '테더 프로토콜 선택',
  ccf: {
    what_ccf: 'USOT란?',
    key_coin: '암호자산을 진짜 화폐로 연결하는 @:(brand.name)의 기축코인',
    ccf_description:
      '다양한 암호자산을 다이렉트 환전과 C2C 거래를 통하여 환산한 @:(brand.name)만의 기축코인이며 1USOT는 USD 1CENT의 가치를 지닙니다. USOT는 @:(brand.name)에서 보다 빠르고 안전한 구매와 거래를 가능하게 합니다.',
    how_use_ccf: 'USOT는 어떻게 사용하나요?',
    brand_wallet_transfer:
      '외부 거래소에 보관된 암호자산을 @:(brand.name)의 지갑으로 이체합니다.',
    ccf_conversion:
      '지갑으로 이체된 암호자산을 다이렉트 환전 또는 C2C 거래를 통하여 USOT로 전환합니다.',
    direct_exchange_c2c_deal: '다이렉트 환전 C2C 거래',
    ccf_moved: '전환된 USOT는 @:(brand.name) 계좌로 옮겨집니다.',
    how_use_account_ccf: '계좌로 옮겨진 USOT는 이렇게 사용해요!',
    freely_purchase_open_market:
      'USOT로 오픈마켓의 상품을 자유롭게 구매해보세요!',
    free_deposit_withdrawal:
      '뱅크 내 계좌 간의 자유로운 입출금과 이체가 가능합니다!',
    exchange_currencies_convenient:
      '다이렉트 환전과 C2C거래를 통해 화폐 간의 교환이 편리해 집니다!',
    offline_convenient:
      '오프라인에서도 @:(brand.name)의 서비스를 보다 편리하게 이용하세요!',
    how_wallets_accounts_different: '지갑과 계좌는 어떻게 다른가요?',
    same_means_storing_cryptocurrency:
      '@:(brand.name)에서 지갑과 계좌는 암호자산을 보관하는 동일한 수단이지만 암호자산의 거래 형태(내외부)에 따라 그 쓰임이 다릅니다. 즉, 거래소와 @:(brand.name) 간의 거래(외부)에서는 지갑이 사용되고, @:(brand.name) 안에서의 거래(내부)에서는 계좌가 사용되는 형태입니다.',
  },
  header: {
    certification_management: '인증/관리',
    c2c_enroll: '구매/판매 등록',
    wallet_list: '지갑/내역 조회',
    wallet: '지갑',
    c2c_list: '구매/판매 내역',
    transfer_list: '환전 내역',
    no_transfer_list: '환전 내역이 없습니다.',
    withdrawal_list: '입/출금 내역',
    my_info: '내 정보',
    home: '메인',
    payment_history: '결제 내역',
    account_transfer: '계좌 이체',
    transfer_history: '이체 내역',
    register_used_account: '자주 사용하는 계좌 등록',
    exchange: '다이렉트 환전',
    do_exchange: '환전 하기',
    exchange_list: '환전 내역',
    email: '이메일',
    email_list: '이메일 내역',
    otp: 'OTP',
    otp_list: 'OTP 내역',
    register_account: '계좌 등록하기',
    calculation_account_list: '정산 계좌 목록',
    security_certification: '보안 인증',
    exact_calculation: '정산용',
    history: '내역',
    information: '정보',
    my_profile: '내 정보',
    email_modify: '이메일 수정',
    password_modify: '비밀번호 수정',
    inquiry: '문의',
    inquiry_history: '문의 내역',
    one_on_one_inquiry: '1:1 문의',
    frequently_asked_questions: '자주묻는 질문',
    announcement: '공지',
    notice: '공지사항',
    server_notice: '서버 공지사항',
    service_center: '고객 센터',
    profile: '회원 정보',
    company: '기업',
    account_management: '뱅킹관리',
    transfer: '이체',
    look_up: '조회',
    email_auth: '이메일 인증',
    email_request: '이메일 문의',
    faq: 'FAQ',
    server: '서버',
    Product_Subscription: '상품&가입',
    easy_payment: '간편 결제',
    easy_login: '간편 로그인',

    product_subscription_list: '상품계좌 조회',
    product_return_list: '자금반환 내역조회',
    product_dividend_list: '배당수령 내역조회',
  },
  footer: {
    footer_msg: '코인관련 계정을 @:(brand.name)에서 이용해 보세요!',
    footer_sub_msg:
      '우리 @:(brand.name)를 통해 거래 및 지갑과 서비스를 이용하시기 바랍니다',
    footer_sub_msg2: 'Tip',
    footer_sub_msg3: '@:(brand.name)는 모든 환경을 지원하고 있습니다.',
    ICO: 'ICO',
    c2c: 'P2P거래소',
    b2c: '현물 거래소',
    margin_exchange: '바이너리 거래소',
    gift_exchange: '선물거래소',
    integrated_exchange: '통합 거래소',
    open_marcket: '오픈마켓',
    game: '게임',
    proceed: '진행중인 거래',
    public: '상장소식',
    direct_ex: '다이렉트 환전',
    buy: '구매하기',
    sell: '판매하기',
    buy_sell: '구매 / 판매',
    holding_coin: '보유코인',
    fee: '수수료안내',
    exchange: '거래소',
    transfer_record: '거래기록',
    Leverage: '레버리지',
    live_exchange: '라이브 거래',
    demo_exchange: '데모 거래',
    contest: '대회',
    powerball: '파워볼',
    law:
      '법률: @.upper:(brand.domain)은 등록번호: 70638826927 (U 6 29 Railway Pde  EastwoodNSW  2122)',
    law1:
      'Trading Point of Financial Instruments Ltd (오스트레일리아)의 전체 소유주인 @:(brand.legalName) 등록번호: 70638826927 상호명입니다.',
    law2:
      '이 웹사이트는 @:(brand.legalName)에 의해 운영됩니다. @:(brand.legalName)는 승인번호 64190 - Auxiliary finance service의 규제를 받고 있으며, 참고번호 70638826927 오스트레일리아에 등록되어 있습니다.',
    law3:
      '@:(brand.name)는 오스트레일리아 금융상품 투자지침에 따라 운영됩니다.',
    law4:
      'ref. no. 538324 | ABN reg. 70638826927 | BA reg. 64190. 거주 국가의 법률 규정에서 @:(brand.name) 서비스 이용이 허용되어 있는지 확인하는 것은 전적으로 고객의 책임입니다.',
    law5: '@:(brand.name)의 위험 공시 전문을 읽어 보시기 바랍니다.',
    law6:
      '@:(brand.name)은 미국, 벨리즈, 모리셔스, 일본, 앨버타,브리티시컬럼비아, 퀘벡, 서스캐처원, 아이티, 수리남, 북한, 푸에르토리코 및 키프로스 점령 지역의 거주민에게 서비스를 제공하지 않습니다.',
    law7:
      '자세한 내용은 자주묻는질문의 규제 부분을 참조하시기 바랍니다. 저희 리스크 공시를 참고해 주시기 바랍니다.',
    law8:
      '제한 지역: Trading Point of Financial Instruments Ltd는 제3세계 국가 지역에 투자 및 부수적 서비스를 제공하지 않습니다.',
    law_warn: '위험 고지 :',
    law_1:
      'CFD는 복잡한 상품이며 레버리지로 인해 빠르게 돈을 잃을 위험이 높습니다. 개인 투자자 계좌 중 69.10%가 CFD를 거래할 때 돈을 잃습니다. ',
    law_2:
      '귀하는 CFD 작동 방식을 이해하고 있는지, 돈을 잃을 위험이 높다는 점을 감수할 수 있는지에 대해 고려해야 합니다. 저희리스크 공시를 참고해 주시기 바랍니다.',
    alert_title: '참고하기 및 유의사항',
    market: '@:(brand.group) 마켓',
    ieo_market: 'IEO 마켓',
    news: 'News',
    event: '이벤트',
    platform_rental_title: '플랫폼임대',
    education: '교육',
    online_Academy: '온라인 아카데미',
    offline_Academy: '오프라인 아카데미',
    shopping_basket: '장바구니',
    best_product: 'Best 상품',
    order: '주문',
    my_page_title: '마이페이지',
    member_info_management: '회원정보 관리',
    order_management: '주문 관리',
    my_question: '나의 질문',
    one_enquiry: '1:1 문의하기',
    community: '커뮤니티',
    lotto: '로또복권',
    rock_event: 'Rock Event',
    quiz_game: '퀴즈게임',
    ladder_game: '사다리타기',
    tetris: '테트리스',
    split_lotto: '나누어로또',
    day_Lottery: '하루 복권',
    attendance: '출석 체크',
    scoop_out: '퍼가기',
    forum: '포럼',
    privacy_state: '개인정보 취급방침',
  },
  main_msg: {
    about_1_title: '세계 최고의 암호자산 거래 서비스',
    about_1_msg: '코인에 관한 모든 서비스를 @:(brand.name)가 선도합니다.',
    about_1_1_msg:
      '전세계에서 처음으로 암호자산 코인을 한 곳에서 구매 판매가 가능합니다.',
    about_1_2_msg:
      '다이렉트 환전에 관해서는 @:(brand.name)에서 이용가능합니다. ',

    about_2_title: '즉시 환전 시스템',
    about_2_msg:
      '@:(brand.name)는 안정적인 다중 평행 매칭 기술을 이용하여 즉시환전이 가능하도록 고도화된 설계기술을 적용한 환전시스템을 보유하고 있습니다',
    about_3_title: '지갑 생성',
    about_3_msg:
      '@:(brand.name)는 국내최고 기술진들로 구성되어진 보안전문가들이 최첨단 보안시스템을 갖추고 WALLET 시스템을 제공합니다.',
    about_4_title: '간편거래시스템(C2C)',
    about_4_msg:
      '@:(brand.name)는 사용자 친화적인 간편거래시스템을 구축하여 보다 편리한 거래를 할 수 있도록 합시다.',
    c2c_main_msg1_1:
      '@:(brand.name)는안정적인 다중 평행매칭 기술을 이용하여 즉시환전이',
    c2c_main_msg1_2:
      '가능하도록 고도화된 설계 기술을 적용한 환전 시스템을 보유하고',
    c2c_main_msg1_3: '있습니다.',
    c2c_main_msg2_1:
      '@:(brand.name)는 국내최고 기술진들로 구성되어진 보안 전문가들이',
    c2c_main_msg2_2: '최첨단 보안시스템을 갖추고 Wallet시스템을제공합니다.',
    c2c_main_msg3_1:
      '@:(brand.name)는 사용자 친화적인 간편거래 시스템을 구축하여 보다',
    c2c_main_msg3_2: '편리한 거래를 할 수 있도록 합니다.',
  },
  toasted_msg: {
    agree_required_term: '필수 약관에 동의해 주세요.',
    must_read_term: '약관을 모두 읽거나 다운로드해야 합니다.',
    pay: '지불완료되었습니다.',
    confirm: '확인되었습니다',
    changed: '변경되었습니다',
    withdrawal: '탈퇴되었습니다',
    register: '등록되었습니다.',
    delete: '삭제되었습니다.',
    title: '알림',
    exchange: '다이렉트 환전이 성공적으로 처리되었습니다.',
    search: '조회되었습니다.',
    deposit_request: '입금 신청 되었습니다.',
    withdraw_request: '출금 신청 되었습니다.',
    create_account: '개설되었습니다.',
    modify: '수정되었습니다.',
    cancel: '취소 되었습니다.',
    trade_confirm: '거래 확정되었습니다.',
    trade_reject: '거래 거부되었습니다.',
    copy: '복사되었습니다.',
    nice_msg:
      '브라우저 설정에서 팝업이 허용되어 있지 않을 경우 본인인증이 정상적으로 진행되지 않습니다.',
    nice_title: '안내',
    nice_success: '본인인증이 성공적으로 처리되었습니다.',
    nice_error: '본인인증을 할 수 없습니다.',
    no_transfer: '환전정보가 없습니다.',
    email_auth: '이메일 인증이 성공적으로 완료되었습니다.',
    email_auth_send: '인증 메일이 발송되었습니다.',
    kyc_withdraw: '계좌인증에 성공했습니다.',
    not_allow_trade: '거래 비활성화 상태입니다.',
    id_find_mail_send: '아이디가 메일로 발송되었습니다.',
    duplicate_check: '아이디 또는 이메일이 중복되었습니다.',
    inquiry_closed: '해당 문의내역이 종결 처리 되었습니다.',
  },
  private: {
    deal_list: '판매 내역',
    app_list: '구매 내역',
    deal_buy_asset: '구매 할 자산',
    buy_price: '구매 가격',
    confirmed_source_amount: '확정 판매 수량',
    holding_source_amount: '미확정 판매 수량',
    potential_source_amount: '가용 수량',
    direct_market: '다이렉트 환전',
    deal_enroll: '판매 등록',
    app_enroll: '구매 등록',
    select_market: '마켓 선택',
    fee_rate: '수수료율',
    deal_info_input: '판매 정보 입력',
    deal_source_amount: '판매 수량',
    deal_price: '개당 판매 가격',
    deal_enroll_account: '판매 등록용 계좌',
    account_select: '계좌 선택',
    direct_asset_select: '판매 및 구매할 자산을 선택해 주세요',
    please_select_asset: '자산을 선택하세요.',
    basic_rate: '현 시세',
    direct_transfer_buy: '즉시 구매 시',
    direct_transfer_sell: '즉시 판매 시',
    direct_source_amount: '환전 수량',
    direct_target_amount: '적용 수량',
    direct_asset_buy: '{0} 로 구매',
    direct_asset_sell: '{0} 로 판매',
    selected_deal_info: '선택한 판매 정보',
    deal_source_asset_title: '구입 자산',
    deal_total_source_amount: '총 판매 수량',
    app_info_input: '구매 정보 입력',
    app_amount: '구입 수량',
    app_deal_price: '개당 가격',
    pay_target_amount: '지불 해야할 수량',
    fee: '수수료',
    fee_calc: '수수료액',
    msg_fee_calc: '{0}만큼 차감됩니다.',
    app_account: '구매 등록용 계좌',
    app_receive_account: '받을 계좌 선택',
    c2c_buy_select_asset: '구매할 자산을 선택해 주세요',
    go_home: '메인으로 돌아가기',
    buy_calc_spread: '구매 환율',
    sell_calc_spread: '판매 환율',
    cs_market_asset: '자산쌍',
    cs_market_basic_rate: '매매기준율',
    transfer_type: '환전 유형',
    exchange_rate: '적용 환율',
    submit_transfer: '즉시 환전',
    deal_source_min_amount: '최소 구매 수량',
    closed_date: '종결일',
    no_deal: '판매 목록 없음',
    app_price_per_quantity: '수량 당 가격',
    app_fee_amount: '수수료 합계',
    select_deal_app_list: '선택한 판매의 구매 내역',
    no_select_deal_app_list: '해당 판매에 구매 내역 없음',
    transfer_source_amount: '기준 자산 수량',
    transfer_target_amount: '상대 자산 수량',
    transfer_basic_rate: '적용 매매기준율',
    transfer_spread_rate: '적용 스프레드율',
    transfer_exchange_rate: '적용 환율',
    transfer_list_detail: '환전 신청 내역 상세',
    transfer_source_asset: '기준 자산',
    transfer_target_asset: '상대 자산',
    transfer_source_account_number: '기준 자산 계좌 번호',
    transfer_target_account_number: '상대 자산 계좌 번호',
    transfer_detail_type: '교환 타입',
    transfer_regdate: '신청 일',
    transfer_asset_info: '{0} 를 {1} 로 {2}',
    transfer_asset_select: '교체할 자산을 선택해 주세요.',
    msg_transfer_buy: '{0} 로 구매',
    msg_transfer_sell: '{0} 로 판매',
    deal_fee_amount: '매도 공시자 부과 수수료',
  },
  wallet_page: {
    have_asset: '보유자산',
    transfer_list: '환전 내역',
    asset_list: '자산목록',
    account_list: '계좌목록',
    account_create: '계좌 생성',
    deposit: '입금',
    withdraw: '출금',
    deposit_list_look: '입금 내역 조회',
    deposit_look: '입금 조회',
    withdraw_list_look: '출금 내역 조회',
    withdraw_look: '출금 조회',
    account_modify: '계좌 수정',
    deposit_apply: '입금 신청',
    withdraw_apply: '출금 신청',
    deposit_request_amount: '입금 금액',
    withdraw_request_amount: '출금 금액',
    withdraw_account_info: '출금 계좌 정보',
    holder_name: '예금주 명',
    bank_name: '뱅크 명',
    withdraw_bank_address: '계좌번호',
    withdraw_address: '자산주소',
    qr_address: '지갑 주소',
    create_qr_address: '지갑주소개설',
    account_enroll: '계좌 등록',
    account_seq: '계좌 고유 번호',
    account_title: '계좌 이름',
    regdate: '개설일',
    before_regdate: '(개설전)',
    holding_balance: '정지금액',
    select_asset: '선택 자산',
    create: '개설',
    deposit_list: '입금 내역',
    no_deposit_list: '입금신청 내역이 없습니다.',
    deposit_apply_detail: '입금 신청 내역 상세',
    asset_title: '자산 명',
    request_amount: '요청 금액',
    withdraw_list: '출금 내역',
    no_withdraw_list: '출금신청 내역이 없습니다.',
    withdraw_apply_detail: '출금 신청 내역 상세',
    withdraw_fee_total_amount: '총 출금액(수수료 포함)',
    net_amount: '최종 금액',
    fee_type: '수수료 유형',
    fee_charge_type: '수수료 부과 유형',
    amount_of_fee: '수수료 부과액',
    create_account_address: '계좌주소개설',
    deposit_msg: '외부 지갑으로부터 나의 {0}지갑으로 {0}를 입금합니다.',
    deposit_msg_1:
      '블록체인 상에서 350번의 승인(컨펌)을 받은 후 {0} 거래 지갑에 반영됩니다.',
    deposit_step_1: 'STEP 1. {0} 메모 ID를 먼저 확인해 주십시오.',
    deposit_step_1_1: '나의 {0} 메모 ID',
    deposit_step_1_2:
      '{0} 입금 시 고객님의 고유 메모 ID를 반드시 표기해야 합니다. 메모 ID 없이 송금된 {0}는 유실됩니다.',
    deposit_step_1_3: '내 {0} 지갑 주소를 봅니다.',
    deposit_step_1_btn: '메모 ID 복사',
    deposit_step_2: 'STEP 2. 내 지갑 주소를 확인해 주십시오.',
    deposit_step_2_1: 'QR 코드',
    deposit_step_2_2: '지갑주소',
    deposit_step_2_3:
      '최소 입금 금액은 <span style="color:#4a90e2">{0} {1}</span> 입니다.',
    deposit_step_2_btn: '지갑주소 복사',
    deposit_msg_2: '확인해 주십시오',
    deposit_msg_2_1: '위 주소는 입금 전용 주소입니다.',
    deposit_msg_2_2:
      '컨펌 완료에 소요되는 총 시간은 블록체인 네트워크의 혼잡도에 따라 영향을 받을 수 있으며, 암호자산별 블록체인 혼잡도는  <span style="color:#4a90e2;cursor:pointer;">여기</span>에서 확인하실 수 있습니다.',
    no_account_list: '계좌목록이 없습니다.',
    no_favorite_account_list: '즐겨찾는 계좌목록이 없습니다.',
    input_account: '변경할 계좌 이름을 입력해주세요.',

    product_subscription_list: '상품계좌 조회',
    product_account_list: '상품계좌목록',
  },
  my_page: {
    my_profile: '내 정보',
    user_unique_num: '회원고유번호',
    user_name: '유저명',
    email_address: '이메일',
    register_regdate: '가입일',
    last_login: '최근 로그인',
    auth_complete: '인증완료',
    not_auth: '미인증',
    expdate: '만료일',
    act_auth: '인증하기',
    realname_auth: '본인인증',
    email_auth: '이메일 인증',
    otp_auth: 'OTP 인증',
    enroll: '등록하기',
    security: '보안등급',
    show_security: '등급보기',
    auth_withdraw_address: '출금 주소인증',
    apply_list: '신청내역',
    password_modify: '비밀번호 수정',
    email_modify: '이메일 수정',
    account_block: '계정 탈퇴',
    placeholder_old_password: '기존 비밀번호를 입력하세요',
    placeholder_new_password: '새로운 비밀번호를 입력하세요',
    placeholder_confirm: '한번 더 입력하세요',
    placeholder_password: '비밀번호를 입력하세요',
    placeholder_email: '새로운 이메일을 입력하세요',
    mail_cert_list: '이메일 신청 내역',
    no_mail_list: '이메일 신청 내역이 없습니다.',
    nominee_detail: '피추천자 내역',
  },
  kyc: {
    register_account: '계좌 등록하기',
    kyc_enroll: 'KYC 인증',
    kyc_enroll_2: 'KYC 주소지 증명',
    kyc_enroll_3: 'KYC 4단계 상향 조정사유',
    auth: '인증',
    auth_code_send: '인증 코드 발송',
    auth_code: '인증코드',
    msg_auth_code: '인증코드를 5분 이내에 입력해 주세요.',
    type_title: '유형명',
    withdraw_auth: '출금 주소 인증',
    withdraw_auth_tit:
      '외부 출금을 위한 출금주소 인증 절차입니다. 출금하실 대상계좌 및 지갑주소를 등록해주시기 바랍니다.',
    select_asset: '자산 선택',
    select_bank: '뱅크 선택',
    holder_name: '예금주 명',
    birth: '생년월일 6자리',
    address: '자산 주소',
    withdraw_list: '출금계좌 신청내역',
    bank_name: '뱅크 명',
    withdraw_info: '출금 계좌 정보',
    withdraw_complete: '이미 인증이 완료된 자산입니다.',
    regdate: '등록일',
    delete_withdraw_address: '출금주소변경',
    delete_success_address: '출금주소가 변경되었습니다.',
    kyc_cert_list: 'KYC 신청 내역',
    no_kyc_list: 'KYC 신청 내역이 없습니다.',
    no_kyc_withdraw_address_list: '출금계좌 신청내역이 없습니다.',
    kyc_placeholder: '을 입력하여 주십시오.',
  },
  otp: {
    enter_verification_number: 'OTP 인증 번호를 입력하세요',
    otp_auth: 'OTP 인증',
    authenticode: 'OTP키',
    otp_deactivate: 'OTP비활성화',
    msg_authenticator_installation:
      '"Google Authenticator" 앱을 스마트폰 또는 데스크톱에 설치해 주세요',
    android: '안드로이드 ',
    or: '또는 ',
    iphone_series: 'iPhone, iPad 그리고 iPod',
    windows_phone: ' Windows Phone',
    and: ', 그리고',
    msg_microsoft_other_systems:
      'Microsoft Windows desktop을 포함한 기타 다른 시스템',
    msg_key: '이 키를 ',
    msg_use_loss_change:
      ' 종이에 적어 주세요. 단말을 잃어버리거나 OTP를 변경해야 할 때 사용됩니다.',
    msg_brcode_touch:
      '"Google Authenticator" 앱을 실행하시고 화면 아래의 <b>Scan QR barcode</b>을 탭해 주세요.',
    msg_input_authenticode:
      '단말의 화면에 표시된 인증코드를 아래의 "인증코드" 란에 입력해 주세요.',
    otp_key: 'OTP 키',
    otp_activate: 'OTP 활성화',
    otp_copy: 'OTP 키가 복사되었습니다.',
    otp_safe_keeping: 'OTP키를 종이에 적은 후 안전한 곳에 보관하셨습니까?',
    yes: '네',
    otp_register: '등록',
    otp_register_success: 'OTP 등록이 성공적으로 완료되었습니다.',
    otp_delete_success: 'OTP 말소 등록이 성공적으로 완료되었습니다.',
    msg_click_key_copy: '클릭하시면 키가 복사됩니다.',
    otp_login: 'OTP 로그인',
  },
  security: {
    show_security: '보안등급 보기',
    grade: '등급',
    condition: '조건',
    restriction: '제한 사항',
    no_grade: '무등급',
    no: '없음',
    security_title: '보안 등급별 조건별 제한사항',
    banner1: '신뢰할 수 있는 보안',
    banner2:
      '@:(brand.name)를 통한 구매 또는 판매에 대해, @:(brand.name)는 데이터 암호화, 실시간 거래 모니터링, 구매자 및 판매자 보호 정책, @:(brand.name)의 안전한 결제 및 결제 수신 방식을 통해 사용자와 모든 결제를 안전하게 보호합니다.',
    banner_invite: '@:(brand.name) 계정이 없으세요?',
    banner_join: '무료 회원가입',

    banner3: '@:(brand.name)가 고객을 안전하게 지키는 방법',
    content1_h3: '구매자 보호 ',
    content1_text:
      '구매자가 오배송 또는 미배송 피해를 입는 경우, @:(brand.name)는 적격한 거래에 대해 배송비를 포함한 전체 결제대금을 보상할 수 있습니다.*',
    content2_h3: '판매자 보호',
    content2_text:
      '판매자가 적격한 판매에 대해 무단 결제 또는 미배송 클레임을 받은 경우, 전체 금액을 보호받을 수있습니다.*',
    content3_h3: '데이터 암호화',
    content3_text:
      'TLS, HTTPS 연결, 모바일 앱의 키 피닝, PCI 준수로 결제를 더 안전하게 지켜줍니다.',
    content3_btn: 'PCI 준수',
    content4_h3: '사기 방지',
    content4_text:
      '모든 거래를 실시간으로 모니터링하고, 계정을 분석하여 사기 활동 및결제를 예방하도록 지원합니다.',
    sec_h2: '구매 여부 확인',
    sec_text:
      '@:(brand.name)는 거래를 24시간 365일 모니터링하므로, 평소와 다른 무언가를 감지한 경우 구매자에게 연락하여 본인의 로그인 또는 구매 여부를 확인하도록 요청합니다. 또한 @:(brand.name)는 이메일을 통해 모든 구매 및 판매를 확인합니다.',
    wran_h2: '의심스러운 점을 발견하면',
    warn_step1: '신고하세요.',
    warn_step1_text1: '승인하지 않은 거래를 발견하면 내용을 확인한 후',
    warn_step1_text2: '문제 신고 > 승인되지 않은 활동 신고',
    warn_step1_text3: '를 클릭하거나 즉시 @:(brand.name)에 연락하세요.',
    warn_step2: '다른 문제가 있는지 확인하세요.',
    warn_step2_text1:
      '최근 거래활동 및 계정 설정을 검토하여 추가 청구 또는 변경사항이 있는지 확인하고, 이 내용 역시 신고하세요.',
    warn_step3: '비밀번호를 변경하세요.',
    warn_step3_text1:
      '보안 메뉴의 계정 설정에서 할 수 있습니다. 또는, 계정에 로그인할 수 없는 경우 ',
    warn_step3_text2: '로그인 > 로그인 문제 해결',
    warn_step3_text3: '을 클릭하여 리셋하세요.',
    warn_btn: '무단 거래 신고',
    online_h2: '@:(brand.name)는 안전한 온라인 활동을 지원합니다.',
    online_h3: '계정 보안',
    online_text: '보안성 높은 비밀번호로 계정을보호하세요.',
    online_btn: '더 알아보기',
    auth_incomplete: '인증 미완료',
  },
  input: {
    id: '아이디를 입력하세요.',
    password: '비밀번호(8자리 이상, 대문자, 특수문자 포함)를 입력하세요.',
    repeat_password: '비밀번호를 재입력하세요.',
    user_name: '유저명을 입력하세요.',
    email_address: '이메일을 입력하세요.',
    mismatch_password: '비밀번호가 일치하지 않습니다.',
    has_min_length: '비밀번호는 최소 8자 이상이어야 합니다.',
    has_special_char: '특수문자가 최소 1개 포함되어야 합니다.',
    has_uppercase: '대문자가 최소 1개 포함되어야 합니다.',
  },
  oauth: {
    contact_msg: '애플리케이션 {0}에서 아래 정보에 접근하려 합니다.',
    agree_msg: '{0} 에서 {1}님의 개인정보에 접근하는 것에 동의하십니까?',
    agree_info:
      '제공된 정보는 이용자 식별, 통계, 계정 연동 및 CS 등을 위해 서비스 이용기간 동안 활용/보관됩니다. 기본정보 및 필수 제공 항목은 @:(brand.name)서비스를 이용하기 위해 반드시 제공되어야 할 정보입니다.',
    agree_request: '제공항목',
    agree_msg2:
      '동의 후에는, 해당 서비스의 이용약관 및 개인정보처리방침에 따라 정보가 관리됩니다.',
    agree: '동의하기',
  },
  pay_head_foot: {
    account_management: '계좌 관리',
    settlement_account_list: '정산계좌 목록',
    account_summary_views: '요약 계좌 조회',
    fund: '자금',
    history: '결제 내역',
    help: '도움말',
    qa: '문의하기',
    fee: '수수료',
    secure: '보안',
    go_shop: '쇼핑하기',
    my_info: '내 프로필',
    my_page: '계정 설정',
    out: '로그아웃',
    in: '로그인',
    about: '회사소개',
    blog: '블로그',
    employ: '채용정보',
    site_map: '사이트 맵',
    developer: '개발자',
    partner: '파트너',
    privacy_state: '개인정보취급방침',
    usage: '이용약관',
    feed_back: '피드백',
    warn_to_consumer:
      '소비자에게 알림: @:(brand.name) 선불 지급 수단의 소유자인 ⓒ @:(brand.name)는 호주 금융감독 당국의 승인을 필요로 하지 않습니다. 이용약관을 주의 깊게 읽어보시기 바랍니다.',
    view_your_account: '전 계좌 조회',
    payment_history: '결제 내역',
    withdrawal_list: '입/출금 내역',
  },
  continue: '계속',
  pay_home: {
    brand_title: '@:(brand.name)',
    platform: '플랫폼',
    platform_rental: '플랫폼 임대하기',
    help: '돕고 있습니다.',
    home_banner_1:
      '전 세계 잠재 고객 기반을 넓히고, 결제 관리를 용이하게 하며,',
    home_banner_2:
      '비즈니스 판매자 보호* 및 연중무휴 사기 방지 모니터링을 통해 안심하고 쇼핑할 수 있도록 합니다. ',
    home_banner_3: '더 쉽게 성공할 수 있습니다.',
    home_banner_warn:
      ' * 판매자 보호 약관이 적용됩니다. 이용 자격에 대한 자세한 내용은 사용자 계약을 참조하세요.',
    home_banner_join: '지금 무료로 가입하세요.',
    home_sec1_openShop: '@:(brand.name)에서 상점을 개설할 수 있습니다.',
    home_sec1_btn: '거래 하기',
    home_sec2_h2: '원하는 방법으로 결제받으세요.',
    home_sec2_text1:
      '@:(brand.name)는 온라인이나 모바일, 심지어 이메일로도 결제 받을 수 있습니다.',
    home_sec2_text2:
      '어디에서 누구에게 판매하시든 @:(brand.name)가 보다 쉽고 안전한 결제를 도와드립니다.',
    home_sec2_online_pay: '온라인 결제',
    home_sec2_online_text:
      '손쉽게 설정 가능한 @:(brand.name)의 결제 버튼은 결제대금과 정기결제, 기부 등을 받을 때도 매우 편리합니다. @:(brand.name) Checkout 을 이용하면 고객이 더욱 쉽고 빠르게 결제할 수 있습니다.',
    home_sec2_online_more: '온라인 결제 더 알아보기',
    home_sec2_voice_invoice: '이메일 인보이스',
    home_sec2_voice_text:
      '전문적인 무료 인보이스로 요청하는 간편한 이메일 결제. 해외 고객은 물론 @:(brand.name) 계정이 없는 고객에게도 사용할 수 있습니다.',
    home_sec2_voice_more: '이메일 인보이스 더 알아보기',
    home_sec2_exchange_pay: '거래소에서 결제하기',
    home_sec2_exchange_text:
      '거래소에서 통합지갑 서비스를 이용하여 파트너사의 어떤 거래소에서도 코인을 충전 및 구매 판매를 이용할 수 있습니다.',
    home_sec2_exchange_more: '거래소 충전 더 알아보기',
    home_sec2_mobile_pay: '모바일 결제받기',
    home_sec2_mobile_text:
      '솔루션은 모바일에 자동으로 최적화됩니다. 전세계 어디서라도 모바일 웹사이트나 Android 및 iOS 앱을 통해 보다 쉽게 결제 받아보세요.',
    home_sec2_mobile_more: '모바일 결제 더 알아보기',
    home_sec3_h2:
      '@:(brand.name) 프리랜서 파트너들과 함께 더 많은 업무를 찾아보세요.',
    home_sec3_global:
      '@:(brand.name)는 세계 최고의 프리랜서 사이트들과 함께 더 많은 글로벌 기회를 연결해 드립니다.',
    home_sec3_btn: '프리랜서를 위한 @:(brand.name) 확인하기',

    home_sec4_h2: '쉽게 시작할 수 있습니다.',
    home_sec4_banner1:
      '@:(brand.name) 비즈니스 허브에서 시작에 필요한 모든 것을 알아보세요.',
    home_sec4_banner2: '비즈니스 계정 가입하고 이메일 주소 확인하기',
    home_sec4_banner3: '인증 완료하고 뱅크 계좌 연결하기',
    home_sec4_banner4: '결제 솔루션 선택하기',
    home_sec5_h2:
      '왜 전 세계 수많은 사업자들이 <br/>@:(brand.name)를 신뢰할까요.',
    home_sec5_sub_text:
      '탁월한 선택이기 때문입니다. @:(brand.name)는 판매자들을 전세계 200여개 시장의 2억 명 이상의 고객에게 25개 통화로 연결해드리고있습니다.',
    home_sec5_sub_text_1:
      '탁월한 선택이기 때문입니다. @:(brand.name)는 판매자들을 ',
    home_sec5_sub_text_2:
      '전세계 200여개 시장의 2억 명 이상의 고객에게 25개 통화로 연결해드리고있습니다.',
    home_sec5_h3: '안전합니다.',
    home_sec5_h3_sub1:
      '자동 사기 판별, 24시간 거래 모니터링과 판매자 및 구매자 보호 프로그램으로 비즈니스와 고객을 안전하게 보호합니다.',
    home_sec5_h3_more: '온라인 결제 더보기',
    home_sec5_h31: '전 세계가 사용합니다.',
    home_sec5_h31_sub1:
      '전세계 누구나 매번 정보를 입력할 필요 없이 빠르게 결제를 진행할 수 있습니다. 203개 시장에서 26개 통화로 신용카드, 직불카드 또는 @:(brand.name)를 통해 결제할 수 있습니다.',
    home_sec5_h31_more: '이메일 인보이스 더보기',
    home_sec5_h32: '빠릅니다.',
    home_sec5_h32_sub1:
      '고객이 결제하면 대부분의 경우 즉시 내 @:(brand.name) 계정으로 입금됩니다. 뱅크로 인출하거나 공급 업체에 대금을 지불하거나 @:(brand.name) 결제가 가능한 모든 곳에서 자유롭게 사용하세요.',
    home_sec5_h32_more: 'eBay 판매 더보기',
    home_sec6_h2: '단순한 수수료 체계',
    home_sec6_sub:
      '@:(brand.name)는 판매가 이루어 질 때 만 수수료를 부과합니다. @:(brand.name) 수수료는 판매 금액과 고객 위치를 기준으로 고정되어 있습니다. ',
    home_sec6_more: '수수료 더 알아보기',
    home_sec7_h2: '한국 셀러를 위한 커뮤니티, CBT LAB',
    home_sec7_text1:
      '크로스보더 트레이드 연구소(CBT LAB)는 @:(brand.name) 코리아(@:(brand.name) Korea)가 해외 전자상거래 활성화를 위해 후원하는 판매자 커뮤니티입니다.',
    home_sec7_text2:
      'CBT LAB은 최신 동향, 팁, 모범 사례와 같은 정보 공유를 동해 비즈니스가 세계적으로 성장할 수 있도록 돕고 있습니다.',
    home_sec7_more: 'CBT LAB 활용 방법 알아보기',

    home_sec8_h2: '@:(brand.name)를 연동한 파트너사를 만나보세요.',
    home_sec8_text1: '온라인 비즈니스를 위한 전문가의 도움이 필요하신가요?',
    home_sec8_text2:
      '웹 호스팅 솔루션, 쇼핑 카트, 이커머스 솔루션 등 @:(brand.name)를 사전 연동한 파트너사들이 여러분의 비즈니스를 도와 드립니다. ',
    home_sec8_text3:
      '내 비즈니스에 적합한 @:(brand.name)의 파트너사를 지금 찾아보세요.',
    home_sec8_more: '더 많은 파트너 보기',
    home_sec9_h2: '글로벌 셀러가 되어보세요. @:(brand.name)가 함께 하겠습니다.',
    home_sec9_h2_1: '글로벌 셀러가 되어보세요.',
    home_sec9_h2_2: '@:(brand.name)가 함께 하겠습니다.',
    home_sec9_btn: '지금 계정 가입하기',

    home_learn_h2: '더 알아보기',
    home_learn_li1: '웹 결제 솔루션',
    home_learn_li1_1: 'Website Payments Standard',
    home_learn_li1_2: '@:(brand.name) Checkout',
    home_learn_li1_3: 'eBay에서 판매하기',
    home_learn_li1_4: '솔루션 비교하기',

    home_learn_li2: '기타 결제',
    home_learn_li2_1: '@:(brand.name) 이메일 인보이스',
    home_learn_li2_2: '모바일 커머스',
    home_learn_li2_3: '비즈니스용 자동결제',
    home_learn_li2_4: 'B2B를 위한 @:(brand.name)',
    home_learn_li2_5: '프리랜서를 위한 @:(brand.name)',

    home_learn_li3: '@:(brand.name) 설정 및 통합',
    home_learn_li3_1: '@:(brand.name) 비즈니스 허브',
    home_learn_li3_2: '@:(brand.name) 코리아 판매자 커뮤니티(CBT LAB)',
    home_learn_li3_3: '사이트에 @:(brand.name) @:(brand.name) 추가하기',
    home_learn_li3_4: '체크아웃 설정 모범 가이드',
    home_learn_li3_5: '개발자',
    home_learn_li3_6: '파트너',
    home_learn_li3_7: '@:(brand.name) 사용법',

    home_learn_li4: '내 계정 관리',
    home_learn_li4_1: '@:(brand.name) 비즈니스 앱',
    home_learn_li4_2: '비즈니스 계정 설정',
    home_learn_li4_3: '판매자 보호 프로그램',
    home_learn_li4_4: '고객 불만 관리하기',
    home_learn_li4_5: '지불거절(Chargeback) 이해하기',
    home_learn_li4_6: '계정 제한 이해하기',
    home_learn_li4_7: '사기 방지 팁',
    home_learn_li4_8: ' PCI 준수',
  },
  pay_nav: {
    view_your_account: '전 계좌 조회',
    account_summary_views: '요약 계좌 조회',
  },
  pay_login: {
    secure_sub_title: '로그인 및 보안',
    secure_my_profile: '내 프로필',
    secure_update_complete: '프로필 및 설정 환경이 업데이트되었습니다.',
    secrue_suggest: '언제든지 고객님의 의견을 말씀해주세요.',
    search: '검색',
    my_info: '개인 정보',
    update: '업데이트',
    e_mail: '이메일',
    default: 'Basic information',
    call: '전화',
    phone: '(휴대폰)',
    pay_mobile: '모바일 결제',
    trading: '주고받기',
    password: '비밀번호',
    change: '변경',
    secure_qa: '보안 질문',
    staying: '더 빠른 구매를 위해 로그인 상태 유지',
    edit: '편집',
    browse_manage:
      '로그인 상태를 유지하도록 선택한 기기 및 브라우저를 관리합니다.',
    account_type: '계정 유형',
    account_delete: '계정 해지',
    business: '비즈니스',
    edit_email: '이메일 주소 편집',
    change_email: '이메일 주소 변경',
    update_email: '이메일 추가',
    eamil_url: '이메일 주소',
    update_email_url: '이메일 주소 추가',
    error_email: '죄송합니다. 기본 이메일은 편집할 수 없습니다.',
    confirm_new_email: '새로운 이메일 주소 확인',
    change_mail: '이메일 변경',
    confirm: '확인',
    changing: '변경',
    deleting: '삭제',
    reaming:
      '현재 이메일 주소 2개가 계정에 연결되어 있습니다. 5개 이메일을 더 추가할 수 있습니다.',
    qa_1: '처음 다녔던 학교의 이름은 무엇인가요?',
    qa_2: '첫 애완동물의 이름은 무엇인가요?',
    edit_phone: '기존 전화번호 편집',
    korea: '대한민국',
    explanation:
      '번호를 추가함으로써 본인은 이 번호를 추가할 권한이 있으며 개인정보 취급방침에 설명된 이유에 따라 자동 다이얼 및 사전 녹음 전화 및 문자 수신에 동의함을 확인합니다. 표준 요금이 적용될 수 있습니다.',
    edit_phone_num: '전화번호 변경',

    edit_password: '비밀번호 변경',
    confirm_password: '현재 비밀번호 확인',
    new_passod: '새 비밀번호',
    confirm_password_new: '새 비밀번호 확인',

    secure_question: '보안 질문',
    secure_pick: '질문 선택',
    secure_answer: '답변',

    edit_browse:
      '@:(brand.name) One Touch를 이용하면 매번 로그인할 필요 없이 빠르게 결제를 완료할 수 있습니다.',
    already_log: '이 기기들에 로그인된 상태입니다.',
    off_all: '모든 기기에서 @:(brand.name) One Touch 끄기',

    support:
      'PayPal은 고객의 100% 만족을 위해 최선을 다하고 있습니다. 계정에 문제가 있는 경우',
    support_center: '고객지원센터',
    support_text1: '에 확인하거나',
    support_text2: '에 문의해 주세요.',
    support_warn:
      '계정을 해지하면 취소할 수 없으며 계정 기록과 신뢰도 수치도 사라지게 됩니다.',
  },
  help: {
    support_center: '지원센터',
    resolution_center: '분쟁해결센터',
    qa_search: '자주 묻는 질문 검색',
    common_qa: '일반 질문',
    common_qa_1:
      '`금액 받기` 링크를 통해 주문 상태를 업데이트한 후 오류 메시지가 표시되는 이유는 무엇인가요?',
    common_qa_2:
      '한국 @:(brand.name) 계정에서 자금을 인출하려면 어떻게 해야 하나요?',
    common_qa_3:
      '내 @:(brand.name) 계정에 직불카드 또는 신용카드를 추가하려면 어떻게 해야 하나요?',
    common_qa_4:
      '내 @:(brand.name) 계정 비밀번호를 잊었습니다. 비밀번호를 재설정하려면 어떻게 해야 하나요?',
    common_qa_5: '이미 보낸 @:(brand.name) 결제대금을 취소할 수 있나요?',
    common_qa_6: '@:(brand.name)를 통해 결제를 받으려면 어떻게 해야 하나요?',
    common_qa_7:
      '@:(brand.name)를 통해 결제대금을 보내려면 어떻게 해야 하나요?',
    common_qa_8:
      '@:(brand.name) 계정에 뱅크계좌를 추가하려면 어떻게 해야 하나요?',
    common_qa_9:
      '내 @:(brand.name) 계정에 연결된 뱅크계좌를 확인하려면 어떻게 해야 하나요?',
    common_qa_10: '@:(brand.name) 계정 제한을 해제하려면 어떻게 해야 하나요?',
    technical_support: '기술 관련 문제 및 업데이트를 구독하세요.',
    muliple_help: '도움을 받는 더 다양한 방법',
    trading_help: '거래 문제 등 해결하기',
    tex_center: '세금 센터',
    tex_help: '세금 양식 및 기타 리소스 찾기',
    need_help: '문의하기',
    help_center: '고객지원센터에 문의하기',
    help_to_center: '고객지원센터에 문의',
    prepare: '준비중입니다.',
    fast_help:
      '@:(brand.name)에서 더 신속하게 도움을 드릴 수 있도록 고객님의 문제를 알려주세요.',
    my_search: '내 문제 검색',
    common_problem: '일반적인 문제',
    login_problem: '로그인 문제',
    unkown_charge: '무단 액세스 또는 모르는 청구 신고',
    send_money: '금액 보내기',
    get_fund: '자금 받기',
    withdraw_money: '금액 인출',
    pay_cancel: '결제 또는 주문 취소',
    pay_hold: '결제 보류 또는 대기 중',
    refund: '환불',
    pre_pament: '사전 승인 결제',
    negative_balance: '마이너스 잔액',
    account_qa_1:
      '내 @:(brand.name) 계정에서 인출 상태가 "완료됨"으로 표시되는데 자금이 뱅크계좌에 들어있지 않는 이유는 무엇인가요?',
    account_qa_2:
      '내 @:(brand.name) 인출이 아직 "대기 중" 상태인 이유는 무엇인가요?',
    account_qa_3: '내 인출이 보류된 이유는 무엇인가요?',
    item_title: '비밀번호 및 계정 액세스',
    item_title_2: '계정 프로필 및 설정',
  },
  business: {
    no_trade: '환전가능한 마켓이 없습니다.',
    view_your_account: '전 계좌 조회',
    available: '사용 가능',
    calculate_late: '가장중요한 USOT 전계좌의 현 자산을 표시해 드립니다. ',
    payment_transfe: '결제대금 이체',
    exchange: '환전',
    currency_update: '통화 추가',
    update_btn: '플러스 버튼',
    currency_cal: '통화 계산기',
    pay_default: '결제 기본설정',
    payment_send: '결제대금 보내기 또는 요청',
    account_list: '계좌목록',
    no_alias: '별칭 없음',
    new_bank: '새 뱅크 연결',
    card: '카드',
    new_card: '새 카드 연결',
    credit: '신용',
    preference_payment: '선호하는 온라인 결제수단을 선택하세요.',
    payment_tip:
      '온라인에서 쇼핑하거나 상품 및 서비스에 대한 결제대금을 보낼 때 이 수단을 사용합니다. 결제 시 언제든지 다른 결제수단을 선택할 수도 있습니다.',
    payment_more: '결제 기본설정에 대해 알아보기',
    paymnet_changes: '@:(brand.name) 잔액',
    debit_card: '직불카드',
    currency_tip:
      '통화를 추가하면 해당 통화로 받는 향후 모든 결제는 해당 잔액으로 입금됩니다. 결제대금을 보내거나 요청할 때 기본 통화가 사용됩니다.',
    currency_1: '호주 달러',
    currency_2: '스위스 프랑',
    currency_3: '체코 코루나',
    currency_4: '덴마크 크로네',
    currency_5: '유로',
    currency_6: '영국 파운드',
    currency_7: '홍콩 달러',
    currency_8: '포린트',
    currency_9: '이스라엘 신 셰켈',
    currency_10: '멕시코 페소',
    currency_11: '노르웨이 크로네',
    currency_12: '뉴질랜드 달러',
    currency_13: '필리핀 페소',
    currency_14: '폴란드 즐로티',
    currency_15: '러시아 루블',
    currency_16: '스웨덴 크로나',
    currency_17: '싱가포르 달러',
    currency_18: '바트',
    currency_19: '신 대만 달러',
    withdraw_account: '출금 계좌',
    exchanged: '환전 후 통화',
    exchange_rate: '환율',
    exchange_tip:
      '이 환율은 현재 환율을 기반으로 한 추정 금액이며, @:(brand.name)의 환전 수수료가 포함됩니다.',
    currency_default: '일본 엔을(를) 기본 통화로 설정합니다.',
    currency_default_notice:
      '결제대금을 보내거나 요청할 때 기본 통화가 사용됩니다.',
    currency_default_notice2:
      '이 통화를 닫으면 다른 결제를 이 통화로 받지 않는 한 잔액에 표시되지 않습니다.',
    currency_default2: 'JPY을(를) 기본으로 설정',
    currency_quit_jp_btn: '일본 달러 닫기',
    currency_quit_btn: '통화 닫기',
    bank_account: '계좌',
    bank_account_create_day: '개설일',
    bank_account_change: '잔액',
    bank_account_check: '뱅크 확인',
    bank_account_remove: '뱅크 삭제',
    bank_continue: '계속하시겠어요?',
    bank_tip: '이 뱅크을 이용한 대기 중인 거래는 삭제한 후에도 처리됩니다.',
    bank_this_delete: '이 뱅크 삭제',
    card_tip:
      '@:(brand.name) 계정을 지출 또는 인출 한도 없이 사용하고 싶으신가요?',
    card_confirm: '카드를 확인하세요.',
    card_type: '유형',
    expiry_date: '만료일',
    card_adress: '청구 주소',
    card_update: '카드 업데이트',
    card_delete: '카드 삭제',
    card_this_delete: '이 카드 삭제',
    card_tip2:
      '현재 선호하는 결제수단입니다. 완료 시 다른 선호하는 결제수단을 설정할 수 있습니다. 이 undefined을(를) 이용한 대기 중인 거래는 삭제한 후에도 처리됩니다.',
    secure_code: '보안코드',
  },
  shop: {
    shop_list: '상점 목록',
    shop_create: '상점 생성',
    shop_cre_date: '등록일',
    shop_title: '상점명',
    shop_id: '상점 ID',
    shop_state: '상태',
    shop_work: '작업',
    shop_detail: '상세',
    shop_retouch: '수정',
    shop_settlement: '정산계좌목록',
    shop_history: '거래내역',
    no_shop_list: '상점목록이 없습니다',
  },
  merchant: {
    create: '상점 등록',
    update: '등록하기',
    retouch: '상점 수정',
  },
  pay_legal: {
    service_usage: '@:(brand.name) 서비스 이용약관',
    detail_usage:
      '이러한 이용약관은 아시아 태평양, 일부 유럽 및 라틴아메리카 국가, 중동 및 아프리카 사용자에게 적용됩니다. 다른 국가 또는 지역에 대한 이용약관을 보려면 아래 목록에서 선택하십시오.',
    nation: '국가 선택',
    every_consumer: '모든 사용자',
    service_agree: '@:(brand.name) 서비스를 위한 사용자 계약',
    privacy_state: '개인정보 취급방침',
    purpose_policy: '@:(brand.name) 이용목적 제한 정책',
    payment_agreement: '@:(brand.name) 대체 결제수단 계약',
    sell_buy: '판매자와 비즈니스',
    shop_policy: '@:(brand.name) 지원 쇼핑몰 정책',
    contract_profit: '영리법인용 계약 ',
    billing_agreement: '청구 계약',
    direct_debit_agreement: '@:(brand.name) 자금 수신 및 자동 이체 계약',
    additional_info: '추가 정보',
    infringement: '침해 소명서 정책',
    policy_update: '정책 업데이트',
    warn1:
      '소비자에게 알림: @:(brand.name) 결제 서비스는 호주 법에 따라 선불 지급 수단(Stored Value Facility)으로 간주됩니다.',
    warn2:
      '@:(brand.name) 선불 지급 수단의 소유자인 ⓒ @:(brand.name)는 호주 금융감독 당국의 승인을 필요로 하지 않습니다. 소비자(사용자)는 이러한 이용약관을 주의 깊게 읽어보시기 바랍니다.',
    warn3:
      '이러한 이용약관과 고지는 특정 @:(brand.name) 서비스와 관련된 이용약관을 제공합니다.',
  },
  pay_privacy: {
    effective_day: '효력 발생일: 2019년 3월 28일',
    summary: '개요',
    personal_data: '@:(brand.name)에서 수집하는 개인 데이터',
    personal_date_cause: '@:(brand.name)에서 개인 데이터를 보관하는 이유',
    summary_1: '은 사용자가 당사',
    summary_2: '사이트',
    summary_3: '를 방문하거나',
    summary_4: '서비스',
    summary_5: '이용 시 사용자의',
    summary_6: '개인 데이터',
    summary_7:
      '를 어떻게 수집하고, 보관하고, 처리하고, 공유하고, 전송하는지에 대하여 설명하기 위해 본 개인정보 취급방침을 마련했습니다. 이 개인정보 취급방침은 당사 사이트를 방문하거나 서비스를 이용할 시 사용자의 개인 데이터에 적용되며, 다른 @:(brand.name)',
    summary_8: '사용자',
    summary_9:
      '의 웹사이트 또는 서비스를 포함한 @:(brand.name)가 소유하거나 조정하지 않는 온라인 웹사이트 또는 서비스에는 적용되지 않습니다.',
    summary2_1:
      '@:(brand.name)는 사용자가 당사의 사이트를 방문하거나 서비스를 이용할 때 다음 유형의 개인 정보를 수집할 수 있습니다.',
    summary2_2: '가입 및 정보 사용',
    summary2_3:
      '@:(brand.name)의 서비스를 이용하기 위해 계정을 만들어 가입하면, 필요한 정보를 충족하여 사용자가 요청하는 서비스를 제공하기 위해 개인 데이터를 수집합니다.',
    summary2_4:
      '선택한 서비스에 따라 사용자의 이름, 우편 주소, 전화번호, 이메일 주소, 계정을 생성하기 위해 필요한 식별 정보 등을 제공해 달라고 요청할 수 있습니다. ',
    summary2_5:
      '이용하시는 서비스에 따라 추가 개인 데이터를 제공해 달라고 요청할 수 있습니다.',
    summary3_1: '거래 및 경험 정보',
    summary3_2:
      '@:(brand.name)의 서비스를 이용하거나 사이트에 접속할 경우, 예를 들어 판매자에게서 구매하거나, 금액을 수령하거나, 결제를 처리하거나, 친구 및 가족에게 금액을 보내실 경우, @:(brand.name)에서 거래 정보뿐만 아니라 기타 거래 관련 정보를 수집합니다. 기타 거래 관련 정보에는 보내거나 요청한 금액, 제품 또는 서비스에 결제한 금액, 거래를 완료하기 위해 사용된 모든 결제수단에 대한 정보를 포함한 판매자 정보, 기기 정보, 기술 사용 데이터, 위치 정보 등이 포함됩니다.',
    summary4_1: '참가자 정보',
    summary4_2:
      '@:(brand.name) 서비스를 이용하거나 사이트에 접속할 때, 사용자가 거래와 관련된 기타 참여자에 대해 제공하는 개인 데이터를 수집합니다.',
    summary4_3: '금액 보내기 또는 요청하기',
    summary4_4:
      '@:(brand.name) 서비스를 통해 금액을 보내거나 요청할 경우 이름, 우편 주소, 전화번호, 사용자로부터 금액을 받거나 사용자에게 금액을 보내는 참여자의 금융 계좌 정보 등의 개인 데이터를 수집합니다. ',
    summary4_5:
      '참여자에 관련하여 요청하는 개인 데이터의 범위는 금액을 보내거나 요청하기 위하여 이용하는 서비스에 따라 달라질 수 있습니다.',
    summary5_1:
      '다른 사람 대신 고지서를 결제하거나 다른 사람에게 고지서 결제 요청하기 ',
    summary5_2:
      '다른 사람 대신 고지서를 결제하거나 다른 사용자에게 자신을 대신하여 고지서를 결제해 달라고 요청하기 위해 @:(brand.name) 서비스를 사용할 경우, 사용자로부터 이름, 우편 주소, 전화번호, 이메일 주소, 사용자가 대신 고지서를 결제하거나 다른 사람이 대신 결제하도록 하려는 계좌 번호를 포함한 계정 소유자 관련 개인 데이터를 수집합니다.',
    summary6_1: '계정에 금액 추가하기',
    summary6_1_1: '사용자의 계정',
    summary6_2:
      '사용자의 계정 또는 사용자가 소유할 수 있는 기타 계정에 금액을 추가하기 위해, 또는 다른 사용자에게 이러한 계정에 금액을 추가해 달라고 요청하기 위해 @:(brand.name) 서비스를 사용할 경우, 요청을 원활히 처리하기 위하여 사용자로부터 상대방에 대한 정보를 수집하거나 상대방으로부터 사용자에 대한 정보를 수집할 수 있습니다. ',
    summary6_3:
      '예를 들어, 휴대폰을 충전하거나 모바일 계좌에 금액을 추가해 달라고 요청하기 위해 @:(brand.name) 서비스를 사용할 경우, 다른 참여자로부터 개인 데이터 및 모바일 계좌 번호를 포함한 기타 정보를 수집할 수 있습니다.',
    summary7_1: '친구 및 연락처에 있는 사람과 관련된 정보',
    summary7_2:
      '사용자가 연락처 목록을 계정에 연결하면 친구 및 연락처에 있는 사람과 거래 시 @:(brand.name)에서 도움을 드리기 더욱 용이합니다. 사용자가 기기 또는 소셜 미디어 플랫폼 간의 연결을 설정하거나 @:(brand.name) 계정을 기기 또는 소셜 미디어 플랫폼과 연결하면 @:(brand.name)에서 연락처 목록 정보(이름, 주소, 이메일 주소 등)를 수집 및 이용하여 더 나은 @:(brand.name) 서비스를 이용할 수 있도록 환경을 개선합니다.',
    summary8_1:
      '사용자가 추가 서비스 또는 특정 온라인 서비스를 이용하기 위해 @:(brand.name)에 제공하기로 선택한 정보 ',
    summary8_2:
      '선택적인 사이트 기능을 요청 또는 참여하거나 향상된 서비스 또는 기타 선택 기능을 요청할 경우, @:(brand.name)에서 사용자에 관한 추가 정보를 수집할 수 있습니다.',
    summary8_3:
      '해당 서비스에서 수집한 정보 사용 방법이 본 개인정보 취급방침에서 밝힌 내용과 다를 경우, 정보 수집 시 따로 고지합니다.',
    summary9_1:
      '"@:(brand.name) 비회원 결제" 서비스를 이용할 경우 사용자에 대한 정보',
    summary9_2:
      '일부 제한된 서비스의 경우 로그인하거나 비회원 결제로 계정 설정을 해야 이용할 수 있습니다. @:(brand.name)는 사용자가 거래를 완료하기 위해 필요한 개인 데이터, 모든 결제수단 관련 기기 정보, 기술 사용 데이터, 위치 정보를 수집합니다. 사용자가 계정 소유자이고 비회원 거래에 대한 결제를 선택했을 경우, 거래 관련 정보를 수집하여 사용자의 계정과 연관지을 수 있습니다.',
    summary9_3:
      '사용자가 계정 소유자가 아니면서 @:(brand.name) 비회원 거래에 대한 결제를 선택했을 경우, 사용자가 제공한 모든 정보를 수집 및 저장하여 해당 정보를 이 개인정보 취급방침에 따라 사용 및 공유합니다.',
    summary10_1: '타사에서 얻는 사용자 관련 정보',
    summary10_2:
      '판매자, 데이터 제공업체, 신용조사기관 같은 제3자로부터 법률이 허가하는 한도 내에서 정보를 얻을 수 있습니다.',
  },
  partner: {
    be_partner: '@:(brand.name)의 파트너가 되어보세요.',
    banner_text:
      '쇼핑몰 플랫폼 제공업체, 마켓플레이스, 결제서비스를 필요로하는 사업자를 지원하는 결제대행업체가 @:(brand.name)의 파트너가 될 수 있습니다.',
    banner_btn: '파트너 담당자에게 문의하기',

    benefit: '@:(brand.name) 파트너가 받을 수 있는 혜택',
    benefit_1: '솔루션 구축을 위한 통합 및 기술 지원',
    benefit_2:
      '@:(brand.name) 통합에 도움을 드리기 위한 지원팀에 언제든지 연락하세요. @:(brand.name) 개발자 포털도 리소스로 활용할 수 있습니다.',
    benefit_3: '마케팅 기회를 통한 비즈니스 성장',
    benefit_4:
      '@:(brand.name)가 제공하는 다양한 마케팅 기회를 활용해 잠재 고객을 유치할 수 있습니다.',

    traction: '전 세계의 결제를 견인하고 있습니다.',
    traction1:
      '@:(brand.name) 파트너들은 @:(brand.name)를 신뢰하는 판매자들의 원활한 결제를 위한 혁신적인 플랫폼을 지원하고 있습니다.',
    traction_btn: '더 많은 파트너 보기',

    program: '@:(brand.name) 파트너 프로그램 가입은 무료입니다.',
    program_1:
      '온라인 양식을 작성해 주시면 @:(brand.name) 에서 연락을 드립니다.',
    program_2: '운영중인 비즈니스와 솔루션에 대해 설명해 주세요.',
    program_3: '필요한 사항을 논의하기 위해 @:(brand.name)에서 연락드립니다.',
    program_4:
      '@:(brand.name)와 통합하고 그들이 @:(brand.name) 결제를 받을 수 있도록 도와주세요.',
    program_btn: '파트너 담당자에게 문의하기',

    common_qa: '자주 묻는 질문',
    common_qa1: '어떤 업체들이 @:(brand.name) 파트너로 있나요?',
    common_qa1_text:
      '@:(brand.name) 파트너는 자사 고객에게 @:(brand.name) 솔루션을 제공하는 B2B(기업 대 기업) 업체들입니다. @:(brand.name)는 쇼핑 카트, 웹 호스팅 업체, 웹 개발자, 물류 업체, 디지털 마케팅 대행사, 결제 게이트웨이 등의 조직과 협력하고 있습니다.',
    common_qa2: '@:(brand.name) 파트너 지원자격은 무엇인가요?',
    common_qa2_text: '파트너 담당자에게 문의',
    common_qa2_text_2:
      '하면 파트너의 자격 요건에 대해 상담 받으실 수 있습니다.',
    common_qa3: '@:(brand.name)에서 통합 지원 서비스를 제공하나요?',
    common_qa3_text:
      '@:(brand.name) 파트너 프로그램에 등록하고 가입을 승인 받으면 유용한 통합 관련 문서 및 개발자 포럼에 접속하실 수 있습니다. 또한 인증서 작성을 위한 통합 컨설턴트의 지원도 받으실 수 있습니다.',
    common_qa4:
      '한국 외에서도 비즈니스를 운영하고 있는데, 파트너 프로그램에 국가별로 따로 가입해야 하나요?',
    common_qa4_text:
      '비즈니스를 운영 중인 국가에 따라 다릅니다. @:(brand.name)에서는 지역별 요구에 특화된 파트너 담당자를 여러 국가에 배치하고 있습니다.',
    common_qa4_more: '파트너 프로그램 제공 국가 보기',
  },
  pay_main: {
    total_product: '상품 합계',
    total_sum: '총계',
    pay_this_account: '이 계좌를 결제수단으로 설정합니다.',
    bill_show: '이 거래 내용은 명세서에 다음과 같이 표시됩니다.',
    banner_text: '@:(brand.name)는 더 안전하고',
    banner_text2: '빠른 결제 방법입니다.',
    banner_text3: '어디에서 쇼핑을 하든 금융 정보를 안전하게 지켜드립니다.',
    footer_1: '약관',
    footer_2: '사용자 계약',
    footer_3: '개인정보 취급방침',
    footer_4: '피드백',
    footer_5:
      '소비자에게 알림: @:(brand.name) 선불 지급 수단의 소유자인 ⓒ @:(brand.name)는 호주 금융감독 당국의 승인을 필요로 하지 않습니다.',
    footer_6: '이용약관',
    footer_7: '을 주의 깊게 읽어보시기 바랍니다.',
    footer_8: '결제',
    wallet: '전자지갑 관리',
    last_name: '성',
    card_number: '카드 번호',
    three_number: '3자리',
    name: '이름',
    pay_brand: '@:(brand.name)로 지불하기',
    free_shipping:
      '@:(brand.name) 계정이 있으면 무료 반품 배송, 구매 보호 등을 받을 수 있습니다.',
    email_phone: '이메일 또는 휴대폰 번호',
    login_error: '로그인에 어려움이 있으신가요?',
    pay_card: '카드로 결제',
    cancel_back: '취소하고 이전페이지로 돌아가기',
  },
  site_map: {
    site_map_tip: '@:(brand.name) 계정을 둘러볼 때 도움이 될 만한 링크입니다.',
    map_fund: '자금',
    map_fund_1: '금액 이체',
    map_fund_2: '내 사용기능 잔액이란?',
    map_fund_3: '금액 보내기 또는 요청',
    map_fund_4: '통화 관리',
    map_fund_5: '내 @:(brand.name) 직불카드 할인',
    map_fund_6: '@:(brand.name) 직불카드 받기',
    map_fund_7: '@:(brand.name) Credit 결제 일정 설정',
    map_deal: '거래',
    map_deal_1: '모든 거래 활동내역 보기',
    map_deal_2: '활동내역 보기(잔액 및 수수료 포함)',
    map_deal_3: '거래 그래프 및 차트 보기',
    map_deal_4: '거래 다운로드',
    map_deal_5: '클레임 또는 지불거절에 응답',
    map_deal_6: 'IPN(즉시 결제 알림) 내역',
    map_profile: '내 프로필 및 설정',
    map_profile_1: '비즈니스 정보 면경',
    map_profile_2: '이메일, 주소, 전화 또는 비밀번호 업데이트',
    map_profile_3: '뱅크계좌 또는 카드 업데이트',
    map_profile_4: '알림 업데이트',
    map_profile_5: '계정 한도 보기',
    map_profile_6: '사용자 관리',
    map_profile_7: '배송 기본설정 업데이트',
    map_support: '지원',
    map_support_1: '분쟁해결센터로 이동',
    map_support_2: '지원센터로 이동',
    map_support_3: '문의하기',
    map_support_4: '@:(brand.name) 판매자 수수료 정보',
    map_report: '보고서',
    map_report_1: '보고서 설정, 관리 또는 다운로드',
    map_manage: '도구',
    map_manage_1: '내 도구 보기',
    map_manage_2: '@:(brand.name) 버튼 관리',
    map_manage_3: '정기결제 관리',
    map_consum: '고객',
    map_consum_1: '고객 목록 보기',
  },
  fee: {
    fee_tip: '단순한 수수료 구조',
    fee_banner_1:
      '일반적으로 구매는 무료이며 환전 수수료가 적용될 수 있습니다.',
    fee_banner_2:
      '@:(brand.name)를 이용해 판매하면 월 수수료 또는 취소 수수료가 붙지 않습니다. 각 판매 후 수수료만 지급하면 됩니다.',
    fee_h2: '일반적으로 구매는 무료입니다.',
    fee_text1: '결제 처리를 위한 수수료는 판매자가 지불합니다.',
    fee_text2: '단, 환전 수수료가 적용될 수 있습니다.',
    fee_more: '판매자 수수료 더 알아보기',
    fee_text3:
      '웹사이트에서 인보이스 또는 이메일 결제를 이용하여 판매하세요.(해외 결제 표준요율 적용)',
    fee_text4: '수령한 통화를 바탕으로 한 고정 수수료',
    fee_text5: '환전 수수료가 추가로 적용될 수 있습니다.',
    fee_text6:
      '예를 들어 USD로 수령된 결제 금액에 대한 고정 수수료는 $0.30 USD입니다.',
  },
  dash: {
    more: '더보기',
    withdraw_asset: '자금 인출',
    currency: '통화',
    quotes: '인보이스 및 견적',
    last_6_months: '최근 6개월',
    make_invoice: '인보이스 생성',
    manage_invoice: '인보이스 관리',
    grown_up: '견적을 보내 비즈니스를 성장시키세요.',
    un_paid_invocie: '미결제 인보이스',
    make_quotes: '견적 생성',
    quotes_1: '1건의 미결제 인보이스가 있습니다.',
    quotes_2: '@:(brand.name) 인보이스',
    quotes_alarm: '미리 알림 보내기',
    quotes_detail: '자세히 표시',
    quotes_who: '청구 대상: 최소영',
    latest_act: '최근 활동내역',
    act: '활동',
    received: '받은 결제대금',
    send: '보낸 결제대금',
    act_record: '활동내역(잔액 및 수수료 포함)',
    pay_person: '결제자 명',
    show_all: '모두 보기',
    tell_us: '의견을 말씀해 주세요.',
    feed_text:
      '잠시 시간을 내어 이 페이지의 새롭게 디자인된 정보 표시에 대한 의견을 말씀해 주세요. 감사합니다!',
    service: '피드백 제공',
    feed_text_back:
      '의견을 보내 주셔서 감사합니다! 우리 사이트가 얼마나 도움이 되었습니까?',
    feed_placeholder:
      '오늘 @:(brand.name)에 온 이유를 알려 주시면 더 좋은 방법이 있습니다. 이메일 또는 계정 번호와 같은 개인 정보를 포함하지 마십시오.',
    feed_p:
      '@:(brand.name) 직원 및 사무실 손님이 볼 수 있도록 귀하의 의견이 내부적으로 게시 될 수 있으므로 개인 정보를 남기지 마십시오. 고객 서비스 문제는 여기를 클릭하십시오. @:(brand.name)의',
    feed_protect: '개인 정보 보호 정책',
    feed_law: '법적 조건',
    feed_or: '및',
    feed_need: '을 참조하십시오',
    trade_name: '거래명',
    trade_id: '거래 ID',
    transaction_type: '거래 유형',
    trade_amount: '결제 금액',
    detail_show: '보기',
  },
  shop_detail: {
    detail_info: '상점 상세 내역',
    api_signature: '상점 서명키',
    msg_shop_create: '상점이 등록되었습니다.',
    msg_shop_modify: '상점이 수정되었습니다.',
  },
  merchant_account: {
    create_account: '정산 계좌 생성',
    enroll_account: '정산계좌 등록',
    pls_select_account: '정산계좌를 선택하세요',
  },
  transaction_detail: {
    transaction_title: '거래 상세 내역',
    order_id: '상점 주문 번호',
    pay_account_title: '지불 계좌 명',
    pay_account_number: '지불 계좌 번호',
    pay_account_balance: '지불 계좌 잔액',
    pay_account_selection: '지불 계좌 선택',
    pay_account_selection_msg: '지불 계좌를 선택해주세요.',
  },
  guide: {
    guide_title_1: '@:(brand.name) 계좌',
    guide_title_2: '@:(brand.name)의 이체와 송금은 어떻게 다른가요?',
    guide_title_3:
      '@:(brand.name)의 계좌를 통해 더욱 편리하고 안전한 서비스를 이용해보세요',

    guide_strapline_1: '① 수수료 없이 바로 송금이 가능한 계좌',
    guide_strapline_2: '② 간편한 방법으로 빠른 계좌 개설 가능',
    guide_strapline_3: '이체',
    guide_strapline_4: '송금',
    guide_strapline_5: '국내에서 가장 많은 종류의 코인을 예치할 수 있는 계좌',
    guide_strapline_6: '해킹으로부터 안전한 계좌',
    guide_strapline_7: '이체 내역 조회 및 영수증 발급 가능',
    guide_strapline_8: '기업 정산 계좌로 사용 가능',
    guide_strapline_9: 'C2C 및 B2C 거래시 계좌를 통해 신속한 거래가 가능',

    guide_strapline_msg_1:
      '@:(brand.name)의 계좌간 송금에는 수수료가 발생하지 않습니다.',
    guide_strapline_msg_3: '@:(brand.name)의 계좌 개설은 10초면 가능합니다.',
    guide_strapline_msg_4: '복잡한 과정은 생략했습니다.',
    guide_strapline_msg_5:
      '해당 자산의 계좌 이름만 입력하시면 바로 생성이 가능합니다.',
    guide_strapline_msg_6: '지갑을 통한 이체',
    guide_strapline_msg_7: '지갑주소 이용',
    guide_strapline_msg_8: '수수료 부과',
    guide_strapline_msg_9: '@:(brand.name) 내에서의 송금',
    guide_strapline_msg_10: '계좌번호 이용',
    guide_strapline_msg_11: '수수료 Zero',
    guide_strapline_msg_12:
      '많은 종류의 암호자산이 전세계에서 발행 되고 있습니다. @:(brand.name)는 이러한 변화에 맞추어 고객의 편의를 돕기 위해 다양한 암호자산을 취급하고 있습니다.',
    guide_strapline_msg_13:
      '보안은 암호자산의 핵심입니다. @:(brand.name)는 보안을 가장 중요하게 생각하여, 각 분야에서 5년이상의 경력을 보유한 디지털 엔지니어들이 보안 시스템을 구축하였습니다.',
    guide_strapline_msg_14:
      '계좌간 이체 내역을 조회할 수 있습니다. @:(brand.name)의 계좌는 시중 은행처럼 뱅크간 또는 타지갑 계좌이체 내역을 확인해볼 수 있습니다. 필요할 경우 지점에 방문하여 발급 내역을 확인 및 출력하실 수 도 있습니다.',
    guide_strapline_msg_15:
      '@:(brand.name)의 계좌는 @:(brand.group) 마켓의 지불 및 정산계좌와 연동됩니다. 대상 암호자산 계좌를 정산 계좌로 등록한 후 @:(brand.group) 마켓에서 판매한 물품의 대금을 암호자산으로 정산이 가능합니다.',
    guide_strapline_msg_16:
      '지갑을 통한 개인간의 거래에는 수수료와 지연이 발생합니다. @:(brand.name)는 이를 해결하는 방법으로 @:(brand.name) 계좌 송금을 제안합니다. @:(brand.name)의 계좌를 통하여 수수료와 지연이 없는 C2C 및 B2C거래를 경험해보십시오.',
  },
  account_transfer: {
    transfer: '계좌 이체',
    transfer_list: '이체 내역',
    transfer_list_title: '@:(brand.name) 계좌 이체',
    transfer_list_wallet: '타 지갑 이체',
    msg_required_data: '값을 모두 입력해주세요',
    msg_not_select_withdraw_account: '출금 계좌를 선택해주세요',
    create_transfer_title: '계좌 이체',
    from_account_select: '출금 계좌 선택',
    available_transfer: '이체 가능 금액',
    to_account_input: '이체 계좌 번호 입력',
    to_account_confirm: '이체 계좌 확인',
    to_account_user_name: '이체 계좌 회원 명',
    transfer_amount: '이체 금액',
    delete_amount: '정정',
    all_amount: '전액',
    description: '설명',
    transfer_btn: '이체',
    transfer_info_check: '이체 신청정보 확인',
    from_account_number: '출금 계좌 번호',
    from_asset_title: '출금 계좌 자산',
    to_account_number: '이체 계좌 번호',
    success_transfer: '이체가 성공적으로 처리되었습니다.',
    transfer_list_detail: '이체 내역 조회',
    search_transfer_asset: '자산 별 검색',
    search_transfer_account: '계좌 별 검색',
    reset: '초기화',
    search: '검색',
    transfer_list_detail_tit: '이체 내역 상세',
    no_transfer: '이체 내역 없음',
    msg_not_search_account:
      '존재하지 않는 계좌 번호 이거나 유효하지 않은 입력 값입니다.',
    my_account_transfer: '본인 계좌 이체',
    msg_pls_select_account: '자산을 선택 후, 계좌를 검색해주세요.',
    placeholder_amount: '이체 금액을 입력해주세요',
    not_search_user_name: '유저명 확인 불가',
    msg_select_asset_search: '계좌를 선택해주세요.',
    register_used_account: '자주 사용하는 계좌 등록',
    success_fail: '이체가 실패되었습니다.',
    pls_search_asset: '자산을 검색해주세요.',
    pls_search_account: '계좌를 검색해주세요.',
    pls_select_asset: '자산을 선택해주세요.',
    not_exist_account: '해당 자산의 계좌가 존재하지 않습니다.',
    no_inquiry_history: '조회내역이 없습니다.',
    account_number_list_1: '6개월 전 이체내역은 조회할 수 없습니다.',
    account_number_list_2: '1회 최대 조회가능기간은 6개월 입니다.',
    account_number_list_3:
      '현 이체결과조회는 @:(brand.name)내의 조회 및 가맹점 이체결과를 조회하는 페이지 입니다. <br/>타 지갑으로 이체결과를 조회 하시고 싶은 분은 상단에 [타 지갑 이체] 에서 확인하시기 바랍니다.',
    account_number_list_3_1:
      '현 이체결과조회는 @:(brand.name)내의 조회 및 가맹점 이체결과를 조회하는 페이지 입니다. <br/>@:(brand.name) 계좌로 이체결과를 조회 하시고 싶은 분은 상단에 [@:(brand.name) 계좌 이체] 에서 확인하시기 바랍니다.',
    today: '당일',
    one_week: '1주일',
    one_month: '1개월',
    three_months: '3개월',
    six_months: '6개월',
    withdrawal_account_number: '출금계좌번호',
    recent_order: '최근순',
    past_order: '과거순',
  },
  bank_service_center: {
    title: '제목',
    date: '등록일',
    state: '상태',
    enter_search_word: '검색어를 입력하세요',
    list: '목록',
  },
  service_center: {
    view_all: '전체 보기',
    contact_history: '문의 내역',
    privacy_Statement: '개인정보취급방침',
    would_you_agree: '위 내용에 동의하시겠습니까?',
    mobile_number: '휴대전화 번호',
    target_of_inquiry: '문의 제목',
    inquiry_contents: '문의 내용',
    please_enter_your_inquiry: '문의 내용을 입력해주세요.',
    send: '보내기',
    normal_inquiries_received:
      '문의하신 내용이 <span class="point-color">정상적으로 접수 완료</span> 되었습니다.',
    inquiry_history: '문의 내역으로',
    pls_select_inquiry_type: '문의 유형을 선택해주세요',
    pls_login_to_use_inquiry: '1:1문의를 이용하려면, 로그인하세요.',
    non_member_login: '비회원 로그인',
    contact_id: '문의 아이디',
    view_inquiry: '문의 보기',
    service_center: '고객센터',
    inquiry_details: '문의 상세',
    msg_enter_title: '제목을 입력하세요.',
    msg_enter_your_content: '내용을 입력하세요.',
    msg_pls_login: '로그인하세요.',
    go_back: '뒤로 가기',
    re_contact: '재문의',
    contents: '내용',
    msg_no_inquiry_history: '문의 내역이 없습니다.',
    msg_require_login_additional_authentication:
      '로그인 또는 추가 인증이 필요합니다.',
    when_you_member: '회원일 때',
    msg_inquiry_history_can_view_after_login:
      ' 회원의 문의 내역은 로그인 후 열람 가능합니다.',
    non_member: '비회원일 때',
    lookup_inquiry: '문의 조회',
    msg_enter_inquiry_id: '문의 아이디를 입력하세요.',
    msg_enter_password_when_registering_your_inquiry:
      '문의 등록 시 설정한 비밀번호를 입력하세요.',
    frequently_asked_questions: '자주 묻는 질문',
    msg_enter_your_password: '패스워드를 입력하세요.',
    pls_search_fap: '질문을 검색해주세요.',
    msg_source_filename_none: '첨부 된 사진이 없습니다.',
    super_inquiry: '상위 문의',
  },
  modal: {
    not_seeing_day: '하루 동안 보지않기',
  },
  login_guide_modal: {
    title: '안내사항',
    sub_title:
      '회원님들의 원활한 거래소 이용을 위하여, 로그인 시스템이 개편될 예정입니다.',
    content:
      '[변경 전] <br/> 최초 가입 시 작성한 ID 로그인 <br/><br/> [변경 후] <br/> 사용중인 전화번호 또는 이메일 로그인으로 변경 <br/><br/> 로그인 시스템이 개편되기 전까지 로그인 하는방법은 최초 가입시 작성해주신 ID로 로그인 해주시면 됩니다.',
  },
  affiliate: {
    affiliate_occur_list: '수당 발생 내역',
    affiliate_adjust_list: '수당 정산 내역',
    allowance_balance_asset: '자산별 수당 잔액',
    list_allowance_balance_asset: '자산별 수당 잔액 목록',
    search_by_asset: '자산별 검색',
    allowance_search: '수당 대상 검색',
    generator: '발생자',
    beneficiary: '수혜자',
    benefactor: '시혜자',
    behavior_type: '행동 유형',
    target_unique_number: '대상 고유 번호',
    date_of_occurrence: '발생일',
    application_policy_name: '적용 정책명',
    beneficiary_type: '수혜자 유형',
    benefactor_type: '시혜자 유형',
    target_amount: '원금액 대상',
    principal_amount: '원금액',
    allowance: '수당',
    allowance_assets: '수당 자산',
    allowance_amount: '수당 금액',
    affiliate_log: '수당 내역',
    allowance_settlement: '수당 정산',
    allowance_settlement_info: '수당 정산 정보',
    name_asset_settled: '수당 정산 받을 자산 명',
    balance_receive_payment: '수당 정산 받을 잔액',
    select_account_settled: '정산 받을 계좌 선택',
    no_affiliate_log: '수당 발생 내역이 없습니다.',
    no_affiliate_balance: '자산별 수당 잔액 목록이 없습니다.',
    no_affiliate_adjust: '수당 정산 내역이 없습니다.',
    asset_name: '자산명',
    asset_code: '자산 코드',
    balance: '잔액',
    cumulative_amount: '누적 금액',
    please_select_account: '계좌를 선택해주세요.',
    calculate: '정산',
    settle: '정산하기',
    calculate_amount: '정산 금액',
    account_number: '계좌 번호',
    registration_date: '등록일',
    number: '번호',
  },
  coin_name: '코인명',
  main_function: '주요 기능',
  disclosure_ing: '공시 중',
  quick_service: '빠른 서비스',
  new_account: '계좌신규',
  social_login: '소셜로그인',
  way_to_find: '찾아 오시는 길',
  korea_head_office: '@:(brand.name) 한국 본점',
  branch_office: '@:(brand.name) 신사점',
  address_head_office: '서울 강남구 언주로 528',
  address_branch_office: '서울특별시 강남구 논현로 803',
  map: '지도',
  korean_language_counseling: '한국어 상담',
  hours_of_business: '한국 10시 ~ 19시 (뱅크휴무일 제외)',
  overseas_consultation: '해외 상담',
  email_consultation: '이메일 상담',

  exchange_price: '  환전/시세',
  market_price_check: '시세조회',
  full_account_inquiry: '전 계좌 조회',
  exchange_details_check: '환전 내역 조회',
  cryptocurrency_exchange_history: '환전 내역',
  deposit_account_inquiry: '자금 예치 계좌 조회',
  transfer_result_check: '이체결과 조회',
  dormant_account_check: '휴면계좌 조회',
  account_and_other_case_status: '@:(brand.name) 계좌 및 타지갑 유무 조회',
  account_and_other_wallet: '@:(brand.name) 계좌 및 타지갑 조회',
  account_search: '@:(brand.name) 계좌 조회',
  other_wallet_search: '타 지갑 이체',

  error_remittance: '@:(brand.name)내 착오송금 반환 동의',

  transfer: '이체',
  other_wallets_transfer: '다른 지갑/이체결과 조회',
  other_wallets_transfer_search: '타 지갑 이체 결과 조회',
  frequently_used_accounts: '자주쓰는 계좌등록/관리',

  new_demand_account: '요구불 계좌 신규',
  new_installment_savings_account: '적금 계좌 신규',
  new_deposit_account: '정기예금 계좌 신규',
  check_account_progress_account: '계좌 신규 진행 상황 조회',

  download: '다운로드',
  withdrawal: '출금',
  Smart_window_withdrawal: '스마트 창구 출금',
  smart_ATM_withdrawal: '스마트ATM출금',

  customer_service: '고객센터',
  notice: '공지사항',
  one_one_inquiry: '1:1문의',
  inquiry_details: '문의내역',
  frequently_asked_questions: 'FAQ',
  server_notice: '서버공지',

  service_hours: '고객만족서비스 운영시간',
  all_day_long: '(24시간 문의 가능)',
  online_service_hours: '온라인 @:(brand.name) 이용시간',
  unusable_hours: '24시 연중무휴 (23:30 - 24:00 이용 불가)',
  offline_hours: '오프라인 뱅크 이용시간',
  offline_bank_hours: '(주말 및 공휴일 휴무)',

  management: '관리',
  secure_management: '보안 인증/관리',
  fund_limit_management: '자금한도관리',
  issue_details_check: '발급내역 조회',
  part_of_news:
    '뉴스 내용 나오는 부분입니다.뉴스 내용 나오는 부분입니다.뉴스 내용 나오는 부분입니다.뉴스 내용 나오는 부분입니다.',
  part_of_notice:
    '공지사항 내용 나오는 부분입니다.공지사항 내용 나오는 부분입니다.공지사항 내용 나오는 부분입니다.공지사항 내용 나오는 부분입니다.',
  full_menu: '전체 메뉴',
  key_coin: '암호자산을 진짜 화폐로 연결하는 @:(brand.name)의 기축코인',
  limitation_info: '전기통신 금융사기 피해예방을 위한 한도제한 안내',
  limitation_info_1:
    '요구불계좌가 비대면으로 개설되면서 자동화기기, 인터넷을 통한 인출(이체)한도는 1일 {0} USOT로 제한됩니다.',
  limitation_info_2:
    '거래목적을 확인 할 수 있는 객관적 인증자료를 지점에 제시 및 “관리 > 보안 인증/관리”에서 한도제한을 해제할 수 있습니다.',
  limitation_info_3:
    '인터넷뱅킹 이용 시 출금계좌로 등록해야 이체거래를 할 수 있습니다.',
  limitation_info_4:
    '암호자산별 한도제한 계좌는 1인당 5개만 개설할 수 있습니다.',
  limitation_notice: '유의사항',
  limitation_notice_1:
    '인터넷뱅킹 가입은 입출금계좌를 개설하신 후 완료화면에서 연동하여 신청할 수 있습니다.',
  limitation_notice_2:
    '기존 인터넷뱅킹 가입 고객은 출금계좌 등록구분이 인터넷+지점으로 되어있을 때만 인터넷 뱅킹으로 출금계좌 등록을 할 수 있음을 유의해주세요.',
  limitation_notice_3:
    '인터넷뱅킹으로 이체거래를 보다 더 간편하게 진행하시려면 보안 인증을 거치셔야합니다. 인증 과정을 통하여 등급을 향상시킨 후 계좌생성 및 출금계좌등록을 진행하시기 바랍니다.',

  new_subscription: '신규가입',
  new_subscription1_1: '신규가입 버튼을 클릭하면 회원님 고유의',
  new_subscription1_2:
    '@:(brand.name) 전용계좌 및 외부 지갑 연동 입금주소가 발급 됩니다.',
  new_subscription2_1:
    '입금 전 꼭 알아두세요! @:(brand.name)전용 계좌에서 계좌로 송금하면 수수료가 일체 없습니다. 신규가입시 발행되는 계좌/주소로는',
  new_subscription2_2:
    '만 입금 가능합니다. 해당 주소로 다른 디지털 자산을 입금 시도할 경우에 발생할 수 있는 오류/손실은 복구 불가능 합니다. 1번의 확인이 발생한 이후, 입금 프로세스를 거쳐 잔고에 반영됩니다. 입금 프로세스는 자동으로 진행되며 네트워크 상황에 따라 소요 시간이 달라 질 수 있습니다. 위 주소는 입금전용 주소입니다.',
  new_subscription3_1: '회원님에게 할당된 신규가입으로는',
  new_subscription3_2: '을 입금할 수 있습니다.',
  new_subscription4: '위 사항을 동의 및 숙지 하셨습니까?',

  created_account_number: '생성된 계좌번호',
  exclusive_account: '@:(brand.name) 전용 계좌번호',
  depositing_external_wallet: '외부지갑에서 @:(brand.name) 입금시',
  use: '사용하기',
  we_future: '우리의 미래',
  pop_brand: '@:(brand.name)',
  fourth_industry: '4차 산업의 선두주자',
  oc_15: '10월 15일',
  officially_open: '정식오픈!',
  head_branch_office: '한국본점(잠실점) / 1호(신사점)',
  sep_15: '9월 15일 오후 5시',
  open_popup: 'OPEN',
  thanks_for: '성원에 감사드립니다.',

  direct_exchange: {
    sell_buy_assets: '판매 및 구매할 자산',
    replace_assets: '교체할 자산',
    ccm_exchange_rate: 'CCM 보유 우대적용환율',
    buy_sell_percent: '구매 -10% 판매 +10%',
    expected_property: '예상 자산',
    preferential_property: '우대받은 자산',
  },

  event_banner: {
    month_hotcoupon: '이달의 HOT 쿠폰을 확인하세요!',
    hotcoupon_sub: '환율우대부터 다양한 제휴쿠폰까지!',
    grab_bug: '버그를 잡아라',
    grab_bug_sub: '1:1문의를 남겨주세요. 추첨을 통해 상품을 드립니다.',
    event2_sub_title: '생애 첫',
    event2_title: '<span style="color: #fffdac">CCM</span> 배당',
    event2_text:
      '<span style="font-weight: 700">가입</span>만 하면 <span style="font-weight: 700">배당금</span>을 펑펑 준다고?<br><span style="font-weight: 700">등급UP</span>만하면<br><span style="font-weight: 700">수수료</span>는 <span style="font-weight: 700">DOWN</span><br><span style="font-weight: 700">배당금</span>이 터져나오는 <span style="font-weight: 700">상품</span><br><span style="font-weight: 700">CCM</span>과의 <span style="font-weight: 700">첫 만남!</span>',
    event2_btn: '가입하기',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: '닫기',
    notice_today: '오늘 하루 보지 않기',
  },
}
